import { LegacyRef } from 'react';

import * as analytics from 'services/analytics/analytics';

const MIDDLE_BUTTON = 1;

export const STRING_REF_ERROR_MESSAGE =
  'InternalLink does not support string innerRef, please use React.createRef';

export function workaroundRef(instance: HTMLAnchorElement | null, ref?: LegacyRef<HTMLAnchorElement>) {
  if (!ref) return;
  if (typeof ref === 'string') {
    window.console.error(STRING_REF_ERROR_MESSAGE);
    return;
  }
  if (typeof ref === 'function') {
    ref(instance);
    return;
  }
  // force this to be mutable in TypeScript
  (ref as any).current = instance;
}

export function createLinkTracker(
  onClick?: React.MouseEventHandler<HTMLAnchorElement>,
): React.MouseEventHandler<HTMLAnchorElement> {
  return e => {
    // call original onClick
    if (onClick) onClick(e);

    // preserve onClick behavior
    if (e.isDefaultPrevented()) return;

    // variable for type checking
    const { href, target, hash, host, pathname, search } = e.currentTarget;

    if (!href) return;

    // handle id anchor tag
    if (
      host === window.location.host &&
      pathname === window.location.pathname &&
      search === window.location.search &&
      !!hash
    )
      return;

    const isOpeningInNewTab = !!target || e.ctrlKey || e.shiftKey || e.metaKey || e.button === MIDDLE_BUTTON;

    if (!isOpeningInNewTab) {
      e.preventDefault();
    }

    const onResponse = () => {
      if (isOpeningInNewTab) return;

      window.location.assign(href);
    };

    analytics.outboundLink({ label: `Navigating to: ${href}` }).then(onResponse, onResponse);

    return false;
  };
}
